const TITLES: [string, string][] = [
  ['/dashboard/messages', 'Messages'],
  ['/dashboard/devices', 'Senders'],
  ['/dashboard/api', 'API keys'],
  ['/dashboard/webhooks', 'Webhooks'],
  ['/dashboard/settings', 'Settings'],
]

export const getPageTitle = (path: string) =>
  TITLES.find(([prefix]) => path.startsWith(prefix))?.[1] ?? 'Overview'
